export { isFileExtensionMatching } from "@finway-group/shared/lib/utils/file.utils"

export const isFileExtensionAllowed = (fileName: string, allowList: ReadonlyArray<string>) => allowList.some((allowedExt) => fileName.toLocaleLowerCase().endsWith(allowedExt))

/** Presigned URLs carry credentials in the query string, so only the host may be sent to error tracking. Never throws — callers use it from error paths. */
export const getReportableFileHost = (filePath: string, baseUrl: string): string => {
    try {
        return new URL(filePath, baseUrl).host
    } catch {
        return "unparsable"
    }
}
